import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const pestControlService = {
    getAllPestControllers,
    updatePestControlStatus,
    getPestControl,
    updatePestControl,
    createPestControl,
};

const MODULE = {
    PEST: 'rnd-product-recommendation-pest-controls',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Cert') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllPestControllers(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.PEST}`, requestOptions)
}


export function updatePestControlStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.PEST}/${data.id}`, requestOptions)
}

export function getPestControl(id) {
    return apiHelper(API_URL).get(`/${MODULE.PEST}/${id}`)
}

export function updatePestControl(data) {
    const requestOptions = {
        product_recommendation_uuid: data.productRecommendationID,
        pest_control: data.pestControl,
        rate: data.rate,
    }

    return apiHelper(API_URL).post(`/${MODULE.PEST}/${data.id}`, requestOptions)
}

export function createPestControl(data) {
    const requestOptions = {
        product_recommendation_uuid: data.productRecommendationID,
        pest_control: data.pestControl,
        rate: data.rate,
    }

    return apiHelper(API_URL).post(`/${MODULE.PEST}`, requestOptions)
}